import { useEffect, useState } from 'react';

import { localStorage } from 'src/lib/localStorage';

const defaults = {
  title: true,
  service: true,
  status: true,
  urgency: true,
  escalationPolicy: true,
  priority: true,
  assignments: true,
  incidentNumber: true,
  pendingActions: true,
  showTimeline: true,
  showNotes: true,
};

const key = 'integration_jira_sidebar_ui_settings';
export const getSettings = () => ({
  ...defaults,
  ...localStorage.getItem(key) || {},
});

export const setSettings = settings => localStorage.setItem(key, settings);

export const useSettings = () => {
  const [settings, setSettings] = useState(getSettings());
  useEffect(() => localStorage.onChange(key, val => setSettings(val || {}), []));
  return settings;
};
